import React, { useCallback } from 'react';
import { Link } from '@adobe/react-spectrum';
import { ImageActions } from 'app/stores/image/actions';
import { useAppDispatch } from 'app/stores/store';
import { useOnline } from 'app/views/hooks/useOnline';
import { analytics } from 'app/utils/analytics';
import { call } from 'app/utils/function';
export const Samples = (props) => {
    const { onSelect } = props;
    const dispatch = useAppDispatch();
    const isOnline = useOnline();
    const onLoadSample = useCallback(() => {
        analytics({
            action: 'LoadSampleImage',
        });
        const sampleUrl = `${window.location.origin}/assets/images/editor/samples/sample01-screenshot-tailwind.png`;
        dispatch(ImageActions.downloadImage(sampleUrl)).then(() => call(onSelect));
    }, [onSelect, dispatch]);
    if (!isOnline) {
        return null;
    }
    return (React.createElement("small", null,
        "I don't trust you at this point. Let me use a \u00A0",
        React.createElement(Link, { onPress: onLoadSample }, "test image")));
};
